import { useQuery } from 'react-query';
import { captureException } from '@sentry/nextjs';
import { OrganizationsService } from '~/src/services/organizations.service';
import type {
    AutocompleteOrganizationDataInterface,
} from '~/src/repositories/organizations/types/organizations.types';
import type { Dispatch, SetStateAction } from 'react';

const QUERY_KEY = 'autocomplete organizations';

export const useFetchAutocompleteOrganizations = (
    searchQuery: string,
    setOrganizationArray: Dispatch<SetStateAction<AutocompleteOrganizationDataInterface[] | []>>,
) => {
    const { refetch } = useQuery([QUERY_KEY, searchQuery],
        () => OrganizationsService.getAutocompleteOrganization(searchQuery), {
            onSuccess: (organizationArray) => {
                const organizationArrayMapped = organizationArray.map((elem) => {
                    return elem.data;
                });
                setOrganizationArray(organizationArrayMapped);
            },
            onError: (error) => {
                captureException(error);
                // eslint-disable-next-line no-console
                console.log(QUERY_KEY, error);
            },
            enabled: false,
        });

    return { refetch };
};